import {ReservationCalendarInput} from 'app/Components/Reservation'
import Text from 'app/Components/twComponents/Text'
import {_} from 'plugins/i18n'
import {fbTrack} from 'plugins/trackers'
import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'
import {calcFirstBookableDate} from './helpers'

// See CalendarInput.tsx for the legend colors
const Legend = () => (
	<div className="flex flex-wrap items-center justify-center gap-8">
		<div className="flex items-center gap-2">
			<div className="h-5 w-10 bg-[#f8d0c7]" />{' '}
			<Text variant="base">{_`unavailable`}</Text>
		</div>
		<div className="flex items-center gap-2">
			<div className="h-5 w-10 bg-white" />{' '}
			<Text variant="base">{_`available`}</Text>
		</div>
		<div className="flex items-center gap-2">
			<div className="h-5 w-10 bg-[#435421]" />{' '}
			<Text variant="base">{_`your selection`}</Text>
		</div>
	</div>
)

class ReservationCalendarSection extends PureComponent {
	static propTypes = {
		isPhone: PropTypes.bool,
		name: PropTypes.string,
		extraContractProps: PropTypes.shape({
			dateRange: PropTypes.object,
			house: PropTypes.object,
		}),
	}

	componentDidMount() {
		fbTrack('InitiateCheckout')
	}

	render() {
		const {extraContractProps, name, isPhone} = this.props
		const {dateRange, house} = (extraContractProps ||
			{}) as ExtraContractPropsType
		const {blockedRanges, switchDay} = house || {}
		const firstAvailableDate = calcFirstBookableDate(house)

		return (
			<div className="flex w-full flex-col items-center justify-center">
				{switchDay >= 0 && (
					<Text variant="headingXL" className="mb-1">
						{_`SwitchDay`} = {_`weekday ${switchDay}`}
					</Text>
				)}
				<Legend />
				<div className="inline-flex w-full items-center justify-center">
					<ReservationCalendarInput
						{...{
							isPhone,
							name,
							numberOfCalendars: 2,
							blockedRanges,
							initialDate: firstAvailableDate,
							switchDay,
							dateRange,
						}}
					/>
				</div>
			</div>
		)
	}
}
ReservationCalendarSection.propTypes = {
	extraContractProps: PropTypes.shape({
		house: PropTypes.object,
		dateRange: PropTypes.object,
	}),
	isPhone: PropTypes.bool,
	name: PropTypes.string,
}
export default ReservationCalendarSection
